/* eslint-disable no-console */
/* eslint-disable @typescript-eslint/no-explicit-any */

export function devLog(...args: any[]) {
  if (process.env.NODE_ENV === 'development') {
    // debug so it's filtered under 'Verbose' in Chrome dev tools and can more
    // easily be toggled on and off for noisiness.
    console.debug(...args);
  }
}
